<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row page-section">
        <div class="col-12 main-content">
          <div class="row">
            <div class="col-12 col-xl-4">
              <b-form-group>
                <label
                  for="extension-input"
                  class="d-inline-block mb-0"
                >{{ 'extension' | i18n }}: </label>
                <b-form-radio-group
                  id="extension-input"
                  v-model="exportExtension"
                  :options="['xml', 'csv']"
                  name="file-extension-options"
                  plain
                />
              </b-form-group>
            </div>
            <div class="col-12 col-xl-4">
              <b-form-group>
                <label
                  for="encoding-input"
                  class="d-inline-block mb-0"
                >{{ 'file_encoding' | i18n }}: </label>
                <b-form-radio-group
                  id="encoding-input"
                  v-model="fileEncoding"
                  :options="fileEncodingOptions"
                  name="encoding-options"
                  plain
                />
              </b-form-group>
            </div>
            <div class="col-12 col-xl-4">
              <b-form-group>
                <label
                  for="all-orders-input"
                  class="d-inline-block mb-0"
                >{{ 'orders' | i18n }}: </label>
                <b-form-radio-group
                  id="all-orders-input"
                  v-model="allOrders"
                  :options="ordersOptions"
                  name="order-options"
                  plain
                />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-button
                size="sm"
                variant="primary"
                class="float-right"
                :disabled="inProgress"
                @click="exportOrders"
              >
                {{ 'export_action' | i18n }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ApiMixin, NotificationMixin} from '../../mixins';
import {BFormRadioGroup} from 'bootstrap-vue';
import PageHeader from '../structure/page-header';

export default {
  name: 'ExportOrders',
  components: {PageHeader, BFormRadioGroup},
  mixins: [ApiMixin, NotificationMixin],
  data: function () {
    return {
      inProgress: false,
      exportExtension: 'xml',
      fileEncoding: 'utf8',
      fileEncodingOptions: ['utf8', 'latin1'],
      allOrders: false,
      ordersOptions: [{
        value: true,
        text: this.$translate('all')
      }, {
        value: false,
        text: this.$translate('not_exported')
      }]
    };
  },
  methods: {
    async exportOrders() {
      try {
        this.inProgress = true;
        await this.apiService.download(`/api/v1/export?extension=${this.exportExtension}&all=${this.allOrders}&fileEncoding=${this.fileEncoding}`, 'export.zip');
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      } finally {
        this.inProgress = false;
      }
    }
  }
};
</script>

<style scoped>
  #extension-input, #all-orders-input, #encoding-input {
    display: inline-block;
    margin-left: 10px;
  }

  ::v-deep   .form-check-inline {
    vertical-align: middle;
  }

  ::v-deep   .form-group {
    margin-bottom: 15px;
    font-size: 0.9rem;
  }
</style>
